// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/****** AIML Loader related CSS starts here ***************/
.aiml-img-loader {
  width: 110px;
  height: 110px;
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 9999999;
  display: none;
}

.aiml-img-loader:before,
.aiml-img-loader:after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: #36f;
  animation: push 1s infinite linear alternate;
}

.aiml-img-loader:after {
  top: auto;
  bottom: 0;
  left: 0;
  background: #0d3491;
  animation-direction: alternate-reverse;
}

@keyframes push {
  0% {
    width: 14px;
    height: 14px;
  }
  100% {
    width: 110px;
    height: 110px;
  }
}
/****** AIML Loader related CSS ends here ***************/`, "",{"version":3,"sources":["webpack://./src/app/system-common/html-body/html-body.component.scss"],"names":[],"mappings":"AAAA,2DAAA;AAEA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAEA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;AACF;;AACA;EACE,SAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;EACA,sCAAA;AAEF;;AAAA;EACE;IACE,WAAA;IACA,YAAA;EAGF;EADA;IACE,YAAA;IACA,aAAA;EAGF;AACF;AADA,yDAAA","sourcesContent":["/****** AIML Loader related CSS starts here ***************/\r\n\r\n.aiml-img-loader {\r\n  width: 110px;\r\n  height: 110px;\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  z-index: 9999999;\r\n  display: none;\r\n}\r\n.aiml-img-loader:before,\r\n.aiml-img-loader:after {\r\n  content: '';\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  width: 110px;\r\n  height: 110px;\r\n  border-radius: 50%;\r\n  background: #36f;\r\n  animation: push 1s infinite linear alternate;\r\n}\r\n.aiml-img-loader:after {\r\n  top: auto;\r\n  bottom: 0;\r\n  left: 0;\r\n  background: #0d3491;\r\n  animation-direction: alternate-reverse;\r\n}\r\n@keyframes push {\r\n  0% {\r\n    width: 14px;\r\n    height: 14px;\r\n  }\r\n  100% {\r\n    width: 110px;\r\n    height: 110px;\r\n  }\r\n}\r\n/****** AIML Loader related CSS ends here ***************/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
